import { useQuery } from "@tanstack/react-query";

import { listWorksiteMembers } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import type { TeamMember } from "../types";
import { toTeamMember } from "../utils/map";

export function useMembers() {
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useQuery({
		queryKey: ["team-members", activeCanteiroId],
		enabled: activeCanteiroId != null,
		queryFn: async (): Promise<TeamMember[]> => {
			const { items } = await listWorksiteMembers(activeCanteiroId as string);
			return items.map(toTeamMember);
		},
		staleTime: 30_000,
	});
}
